<template>
  <div id="app">
    <AppLayout>
      <router-view />
      <div v-if="hideHomeButtom" id="nav">
        <router-link to="/home">{{ $t('Common.home') }}</router-link>
      </div>
      <div>
        <span class="recommendation-text">{{ $t('Common.browserRecommendation') }}</span>
      </div>
    </AppLayout>
  </div>
</template>

<script>
import AppLayout from './components/AppLayout'
// import { getOssAuth } from './util/file'

export default {
  name: 'App',
  components: {
    AppLayout
  },
  data: function () {
    return {
      blockHomeName: [
        'home',
        'fullfillInfo',
        'login',
        'typingSingleBasic',
        'typingSingleIntermediate',
        'typingSingleAdvanced',
        'typingCombineIntermediate',
        'typingCombineAdvance',
        'typingEssay',
        'forgetNumber'
      ]
    }
  },
  computed: {
    hideHomeButtom () {
      return this.blockHomeName.indexOf(this.$route.name) === -1
    }
  },
  mounted () {
    // getOssAuth()
  }
}
</script>

<style lang='scss'>
// @import '@/styles/globalStyles.scss'
html,
body,
#app {
  width: 100%;
  color: #4a4a4a;
  font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB",
    "Heiti SC", "STXihei", "Microsoft YaHei", "SimHei", "WenQuanYi Micro Hei",
    sans-serif;
  overflow: auto;
  text-align: center;
  background-color: #eeeeee;
  overflow-x: hidden;
}

#nav {
  padding: 10px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.recommendation-text {
  color: #000000;
  font-size: 14px;
}
</style>
